import { createPartnerAdminApiStore } from '@/api'

const apiStore = createPartnerAdminApiStore([
  {
    action: '_companyAccountsDetail',
    path: 'v2/partners/my',
    method: 'get',
    cacheable: false
  }
])

const PAGE_DATA = () => {
  return {
    pageIndex: 1,
    pageCount: 30,
    format: ''
  }
}

const SEARCH_DATA = () => {
  return {
    beginAt: null,
    endAt: null
  }
}

const INIT_DATA = () => {
  return Object.assign({}, SEARCH_DATA(), PAGE_DATA())
}

export default {
  namespaced: true,
  mixins: [apiStore],
  state: {
    listParams: INIT_DATA(),
    total: 0
  },
  actions: {
    companyAccountsDetail({ state, dispatch, commit }, params) {
      return dispatch('_companyAccountsDetail', { params: params })
    }
  },
  mutations: {
    SET_SEARCH_PARAMS(state, params) {
      state.listParams.beginAt = params.beginAt
      state.listParams.endAt = params.endAt
    },
    SET_PAGE_PARAMS(state, params) {
      state.listParams.pageIndex = params.pageIndex
      state.listParams.pageCount = params.pageCount
      state.listParams.format = params.format
    },
    INIT(state) {
      state.listParams = INIT_DATA()
    }
  },
  getters: {
    listParams: (state, getters) => {
      return state.listParams
    }
  }
}
